<!-- Normal view -->
@if (!fullscreen()) {
  <div class="relative flex flex-col w-full h-full">
    @if (error) {
      <div class="flex flex-col items-center justify-center w-full h-full gap-2 p-6 text-center text-red-700">
        <mat-icon class="!h-[48px] !w-[48px] text-[48px]">broken_image</mat-icon>
        <span class="text-lg font-medium">{{ error }}</span>
      </div>
    }

    <div
      class="relative flex-1 w-full min-h-0 overflow-auto border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-900 dark:border-gray-700"
      [style]="wordActionsNormal ? 'height: calc(100% - ' + wordActionsNormal.offsetHeight + 'px)' : ''"
      (wheel)="onWheel($event)"
    >
      @if (isLoading && !error) {
        <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/50 dark:bg-black/50">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
      }

      <div
        #wordContainer
        class="transition-transform duration-200"
        [style.zoom]="zoomLevel"
      >
        <!-- Docx-preview content goes here -->
      </div>
    </div>

    <!-- Zoom Controls -->
    <div
      #wordActionsNormal
      class="pointer-events-none absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 rounded-3xl bg-[var(--mat-sys-surface-container-highest)] bg-opacity-90 px-3 py-1.5 shadow-md dark:bg-[var(--mat-sys-surface-container-lowest)]"
    >
      <button
        mat-icon-button
        class="pointer-events-auto !h-8 !w-8 transition-colors duration-200 disabled:opacity-40"
        (click)="zoomOut()"
        [disabled]="zoomLevel <= 0.5"
      >
        <mat-icon class="text-[20px]">zoom_out</mat-icon>
      </button>
      <span class="min-w-[40px] text-center text-xs font-medium"
        >{{ zoomLevel * 100 | number: '1.0-0' }}%</span
      >
      <button
        mat-icon-button
        class="pointer-events-auto !h-8 !w-8 transition-colors duration-200 disabled:opacity-40"
        (click)="zoomIn()"
        [disabled]="zoomLevel >= 3"
      >
        <mat-icon class="text-[20px]">zoom_in</mat-icon>
      </button>
      <div class="w-px h-4 mx-1 bg-gray-300 dark:bg-gray-600"></div>
      <button
        mat-icon-button
        class="pointer-events-auto !h-8 !w-8 transition-colors duration-200"
        (click)="resetZoom()"
      >
        <mat-icon class="text-[20px]">refresh</mat-icon>
      </button>
    </div>
  </div>
}

<!-- Fullscreen Overlay -->
@if (fullscreen()) {
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center"
    (click)="fullscreen.set(false)"
  >
    <!-- Backdrop con blur -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

    <!-- Popup container con sfondo di sistema -->
    <div
      class="surface relative z-10 flex h-[85vh] w-[90vw] flex-col overflow-hidden rounded-xl shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <!-- Header con bottone close -->
      <div class="flex items-center justify-end gap-2 p-2">
        <ng-container
          *ngTemplateOutlet="actionsTemplate() || null"
        ></ng-container>
      </div>

      <!-- Word Content Area -->
      <div class="relative flex-1 p-4 overflow-hidden">
        @if (error) {
          <div class="flex flex-col items-center justify-center w-full h-full gap-2 p-6 text-center text-red-700">
            <mat-icon class="!h-[48px] !w-[48px] text-[48px]">broken_image</mat-icon>
            <span class="text-lg font-medium">{{ error }}</span>
          </div>
        }

        <div
          class="w-full h-full overflow-auto"
          [style]="wordActionsFullscreen ? 'height: calc(100% - ' + wordActionsFullscreen.offsetHeight + 'px)' : ''"
          (wheel)="onWheel($event)"
        >
          @if (isLoading && !error) {
            <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/50 dark:bg-black/50">
              <mat-spinner diameter="48"></mat-spinner>
            </div>
          }

          <div
            #wordContainer
            class="transition-transform duration-200"
            [style.zoom]="zoomLevel"
          >
            <!-- Docx-preview content goes here -->
          </div>
        </div>

        <!-- Zoom Controls -->
        <div
          #wordActionsFullscreen
          class="pointer-events-none absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 rounded-3xl bg-[var(--mat-sys-surface-container-highest)] bg-opacity-90 px-3 py-1.5 shadow-md dark:bg-[var(--mat-sys-surface-container-lowest)]"
        >
          <button
            mat-icon-button
            class="pointer-events-auto !h-8 !w-8 transition-colors duration-200 disabled:opacity-40"
            (click)="zoomOut()"
            [disabled]="zoomLevel <= 0.5"
          >
            <mat-icon class="text-[20px]">zoom_out</mat-icon>
          </button>
          <span class="min-w-[40px] text-center text-xs font-medium"
            >{{ zoomLevel * 100 | number: '1.0-0' }}%</span
          >
          <button
            mat-icon-button
            class="pointer-events-auto !h-8 !w-8 transition-colors duration-200 disabled:opacity-40"
            (click)="zoomIn()"
            [disabled]="zoomLevel >= 3"
          >
            <mat-icon class="text-[20px]">zoom_in</mat-icon>
          </button>
          <div class="w-px h-4 mx-1 bg-gray-300 dark:bg-gray-600"></div>
          <button
            mat-icon-button
            class="pointer-events-auto !h-8 !w-8 transition-colors duration-200"
            (click)="resetZoom()"
          >
            <mat-icon class="text-[20px]">refresh</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
}
